var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefitIconMobile3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8384_14178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9226 10.7806V4.38428L41.9531 13.9787L27.9226 23.5731V17.1769H24.678C15.374 17.1769 6.8767 21.9661 2.72014 29.5537L1.61523 31.5685C1.61523 20.0872 11.8225 10.7806 24.4149 10.7806H27.9226Z",
    stroke: "#187C85",
    strokeWidth: 1.12277,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8687 22.2384C31.5586 22.2384 31.3073 22.4898 31.3073 22.7998C31.3073 23.1098 31.5586 23.3612 31.8687 23.3612V22.2384ZM36.6917 22.7998H37.2531C37.2531 22.4898 37.0017 22.2384 36.6917 22.2384V22.7998ZM36.6917 41.2149V41.7763C37.0017 41.7763 37.2531 41.525 37.2531 41.2149H36.6917ZM1.61523 41.2149H1.05385C1.05385 41.525 1.30519 41.7763 1.61523 41.7763L1.61523 41.2149ZM31.8687 23.3612H36.6917V22.2384H31.8687V23.3612ZM36.1303 22.7998V41.2149H37.2531V22.7998H36.1303ZM36.6917 40.6535H1.61523V41.7763H36.6917V40.6535ZM2.17662 41.2149V34.3093H1.05385V41.2149H2.17662Z",
    fill: "#187C85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3857 22.7998L26.1701 22.7998",
    stroke: "#187C85",
    strokeWidth: 0.876911,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6405 37.752C22.1843 37.752 24.2547 35.2748 24.2547 32.2283C24.2547 29.1818 22.1843 26.7046 19.6405 26.7046C17.0968 26.7046 15.0264 29.1818 15.0264 32.2283C15.0264 35.2748 17.0968 37.752 19.6405 37.752ZM19.6405 27.8877C21.5261 27.8877 23.0642 29.8325 23.0642 32.2283C23.0642 34.6241 21.5261 36.5689 19.6405 36.5689C17.7549 36.5689 16.2169 34.6241 16.2169 32.2283C16.2169 29.8325 17.7549 27.8877 19.6405 27.8877Z",
    fill: "#187C85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59254 35.4445C7.53904 35.4445 8.30807 36.2135 8.30807 37.16C8.30807 37.4854 8.57427 37.7516 8.89963 37.7516H12.9148C13.2402 37.7516 13.5064 37.4854 13.5064 37.16C13.5064 36.8347 13.2402 36.5685 12.9148 36.5685H9.43203C9.19541 35.4445 8.30807 34.5571 7.1841 34.3205V30.1278C8.30807 29.8912 9.19541 29.0039 9.43203 27.8799H12.9148C13.2402 27.8799 13.5064 27.6137 13.5064 27.2883C13.5064 26.963 13.2402 26.6968 12.9148 26.6968H8.89963C8.57427 26.6968 8.30807 26.963 8.30807 27.2883C8.30807 28.2348 7.53904 29.0039 6.59254 29.0039C6.26718 29.0039 6.00098 29.2701 6.00098 29.5954V34.8529C6.00098 35.1783 6.26718 35.4445 6.59254 35.4445Z",
    fill: "#187C85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8605 36.5611H26.3777C26.0523 36.5611 25.7861 36.8273 25.7861 37.1527C25.7861 37.4781 26.0523 37.7443 26.3777 37.7443H30.3929C30.7183 37.7443 30.9845 37.4781 30.9845 37.1527C30.9845 36.2062 31.7535 35.4372 32.7 35.4372C33.0254 35.4372 33.2916 35.171 33.2916 34.8456V29.5881C33.2916 29.2627 33.0254 28.9965 32.7 28.9965C31.7535 28.9965 30.9845 28.2275 30.9845 27.281C30.9845 26.9557 30.7183 26.6895 30.3929 26.6895H26.3777C26.0523 26.6895 25.7861 26.9557 25.7861 27.281C25.7861 27.6064 26.0523 27.8726 26.3777 27.8726H29.8605C30.0971 28.9965 30.9845 29.8839 32.1084 30.1205V34.3132C30.9845 34.5498 30.0971 35.4372 29.8605 36.5611Z",
    fill: "#187C85"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8384_14178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.0917,
    height: 42.0917,
    fill: "white",
    transform: "translate(0.739258)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitIconMobile3);
export default __webpack_public_path__ + "static/media/benefit-icon-mobile3.d0e2e25438e021e088f65d0735d08da8.svg";
export { ForwardRef as ReactComponent };